module.exports = __webpack_public_path__ + "static/AboutUs-KunalProfilePic-3e201ae9cc156f2945b12f867b50dd56.jpg";